{% import Exception from './exception' %}

<div class="schema-fragment-wrapper {{ theme ? 'theme-' + theme + '-wrapper' : '' }}">
    <div class="schema-fragment {{ theme }}">
        <div class="code-area">
            <textarea></textarea>
        </div>
    </div>
</div>

